// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__BoLdW","footer":"ModalCreateQualiphyProcedure_footer__1vXYJ","additionData":"ModalCreateQualiphyProcedure_additionData__dijZW"};